<template>
  <div
    class="mapContainer-errand"
    :class="{ sideBarActive: $store.state.sidePanel }"
  >
    <v-snackbar :color="snackbarColor" top :timeout="5000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>

    <svg
      style="width: 0; height: 0; position: absolute"
      xmlns="http://www.w3.org/2000/svg"
    >
      <filter id="shadow">
        <feDropShadow
          dx="0"
          dy="0"
          stdDeviation="4"
          flood-color="#FF1744"
          flood-opacity="1"
        />
      </filter>

      <filter id="shadowAlt">
        <feDropShadow
          dx="0"
          dy="0"
          stdDeviation="4"
          flood-color="#00cdbc"
          flood-opacity="1"
        />
      </filter>

      <linearGradient id="linearGradient" x1="0" x2="0" y1="0" y2="1">
        <stop offset="40%" stop-color="#00cdbc" />
        <stop offset="50%" stop-color="#FF1744" />
      </linearGradient>
    </svg>

    <l-map
      ref="myMap"
      @update:center="centerUpdated"
      :zoom="zoom"
      :center="center"
      :tap="false"
      :options="mapOptions"
    >
      <l-tile-layer :url="url" :attribution="attribution" />

      <l-marker
        :draggable="true"
        @update:lat-lng="positionUpdated($event, id)"
        v-for="(e, id) of waypoints"
        :lat-lng="[e.lat, e.lng]"
        :key="id"
      >
      </l-marker>

      <l-polyline :weight="7" :lat-lngs="polygon" color="#00cdbc"></l-polyline>

      <l-control-zoom
        class="d-none d-sm-block d-md-block"
        position="bottomright"
        zoomInText='<i class="fas fa-search-plus"></i>'
        zoomOutText='<i class="fas fa-search-minus"></i>'
      ></l-control-zoom>
    </l-map>
    <button
      v-if="position"
      @click="centerMyPosition()"
      id="position"
      class="triggerPanel sideBarActive"
    >
      <i class="fas fa-crosshairs"></i>
    </button>

    <div v-if="waypoints.length > 1" class="createBtn d-sm-none d-lg-none">
      <div class="information">
        <h2 class="mb-0 pb-0 primary--text">
          {{ routeCost ? routeCost : 0 | currency }}
          <!-- <span class="primary--text font-weight-bold pb-3" style="font-size:13px">
            ({{ (routeData.routeDistance / 1000).toFixed(2) }} KM)</span
          > -->
        </h2>
        <small
          @click="showTimePicker"
          style="cursor: pointer"
          class="ma-0 pa-0 font-weight-bold"
        >
          Entrega : {{ deliveryTime }}
        </small>
      </div>
      <v-btn
        class="d-block d-md-none d-sm-block"
        rounded
        @click="confirmDialog = true"
        style="z-index: 2"
        color="primary"
      >
        Continuar
      </v-btn>
    </div>
    <div
      v-if="
        business &&
        ((waypoints.length && business.canChangeSecondaryPoints) ||
          (!waypoints.length && business.canChangeStartingPoint)) &&
        waypoints.length < business.pointsNumber
      "
      class="searchGeo"
      v-show="!editPointDialog"
    >
      <i class="far fa-search"></i>
      <input
        type="text"
        v-model="searchTerm"
        v-on:keyup.enter="geoQuerySearch()"
        v-on:keyup.escape="searchResults = []"
        placeholder="Busca una dirección o ingresa las coordenadas"
      />
      <!-- <transition name="slide" appear> -->
      <div v-if="searchResults.length" class="matches">
        <ul>
          <li
            v-for="result in searchResults"
            :key="result.properties.osm_id"
            @click="geoQuerySelect(result)"
          >
            <i class="fas fa-map-marker-alt"></i> {{ result.name }}
          </li>
        </ul>
      </div>
      <!-- </transition> -->
    </div>

    <div class="tag">Mandado Solo</div>

    <transition name="appear-reverse" appear>
      <points-details
        :routeData="routeData"
        ref="detail"
        v-if="!isMobile"
        @edit="editPointFields"
        @delete="deletePoint2"
        @positionUpdated="positionsUpdated"
        :business="business"
        @create="preValidation"
        :waypoints="waypoints"
        @show="showChanged"
      />
    </transition>

    <v-dialog width="400" v-model="exitDialog">
      <v-card class="pl-3 pr-3">
        <v-card-title>
          ¿Está seguro que desea salir?
          <v-btn
            style="right: 10px; top: 10px"
            icon
            color="primary"
            fab
            absolute
            @click="cancel"
          >
            <v-icon dark style="font-size: 20px">fa-times</v-icon>
          </v-btn></v-card-title
        >

        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="mt-0 pt-0" cols="12" sm="12" md="12">
                <h3 class="black--text mt-3" style="text-align: center">
                  La ruta definida será eliminada
                </h3>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mt-0 pa-0 pb-3">
          <v-row class="ma-0 pa-0">
            <v-col cols="6" sm="6" md="6">
              <v-btn height="50" rounded block @click="cancel" color="gray"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-btn
                height="50"
                class="white--text"
                rounded
                block
                @click="exit"
                color="red"
                >Salir</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="650" persistent v-model="showDetails" v-if="showDetails">
      <details-dialog
        :routeData="routeData"
        :waypoints="waypoints"
        @success="createErrand"
        ref="confirmErrand"
        @cancel="showDetails = false"
      ></details-dialog>
    </v-dialog>

    <transition name="fade">
      <edit-point
        v-if="editPointDialog"
        :point="pointToEdit"
        @success="updatePoint"
        @cancel="editPointDialog = false"
      ></edit-point>
    </transition>

    <transition name="fade">
      <confirm-errand
        v-if="confirmDialog"
        :routeData="routeData"
        @success="preValidation"
        :waypoints="waypoints"
        @cancel="closeConfirm"
      ></confirm-errand>
    </transition>

    <v-dialog
      width="500"
      style="z-index: 345"
      persistent
      v-model="timePickerDialog"
      v-if="timePickerDialog"
    >
      <time-picker
        @success="timeSelected"
        :timeData="timeData"
        @cancel="timePickerDialog = false"
      ></time-picker>
    </v-dialog>
  </div>
</template>

<script>
import L from "leaflet";
import axios from "axios";
import { latLng, divIcon } from "leaflet";
import { Icon } from "leaflet";
import { db, fb } from "@/firebase";
import points from "@/components/points";
import detailsDialog from "@/components/details-dialog";
import editPoint from "@/components/edit-point";
import pointsDetails from "./details";
import confirmD from "@/components/confirm";
// import { mobile } from "is-mobile";
var mobile = require("is-mobile");
import timePicker from "@/components/timePicker";

import {
  LMap,
  LTileLayer,
  LControlZoom,
  LMarker,
  LPopup,
  LTooltip,
  LGeoJson,
  LPolyline,
} from "vue2-leaflet";

require("leaflet-routing-machine");
require("leaflet-control-geocoder");

import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");
import confirmErrand from "./confirm.vue";
import { mapActions } from "vuex";

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("@/assets/marker.svg"),
  iconUrl: require("@/assets/marker.svg"),
  iconSize: [0, 0],
});

export default {
  name: "LeafletMap",
  components: {
    LMap,
    LTileLayer,
    LControlZoom,
    LMarker,
    LPopup,
    LTooltip,
    points,
    detailsDialog,
    editPoint,
    pointsDetails,
    confirmD,
    confirmErrand,
    // optionsDialog,
    timePicker,
    LGeoJson,
    LPolyline,
  },
  data() {
    return {
      globals: null,
      showDetailsPanel: true,
      myLocationMarket: null,
      pointToEdit: {},
      snackbarText: "",
      snackbar: false,
      selectedIndexPoint: null,
      editPointDialog: false,
      snackbarColor: "red darken-2",
      version: process.env.VUE_APP_VERSION,
      business: null,
      showDetails: false,
      pointsReference: null,
      confirmDialog: false,
      to: null,
      city: null,
      card: null,
      position: null,
      searchTerm: null,
      searchResults: [],
      useGoogleSearch: false,
      points: [],
      polygons: [],
      polygon: [],
      exitDialog: false,
      selectedStartingPoint: null,
      selectedDestinationPoint: null,
      activeButton: true,
      selectedPoint: null,
      currentZone: "",
      generating: false,
      detailsActive: true,
      isMobile: false,
      zoom: 15,
      serverUrl: null,
      center: latLng(14.075104529559956, -87.19571461307869),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      showParagraph: false,
      map: null,
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false,
        tap: false,
      },
      waypoints: [],
      timePickerDialog: false,
      timeData: {
        soon: true,
      },
      routeData: {
        routeName: "Agrega puntos al mapa para empezar",
        routeDistance: 0,
        routeTime: 0,
      },
      // geojson: null,
      routeCost: 0,

      // geojson : []
    };
  },
  watch: {
    // async waypoints(e) {
    // },
  },
  beforeDestroy() {
    if (this.unsubscribeSchedule) this.unsubscribeSchedule();
    let menu = document.getElementById("menu");
    menu.classList.remove("router-link-exact-active");
    menu.classList.remove("router-link-active");
  },

  async mounted() {
    // Validación de horario al cargar la vista
    const businessRef = db.collection("businessesCorporative").doc(this.$store.state.user.businessID);
    const checkSchedule = (schedule) => {
      const currentDay = new Date().toLocaleDateString("en-US", { weekday: "long" }).toLowerCase();
      const capitalizedDay = currentDay.charAt(0).toUpperCase() + currentDay.slice(1);
      const isDayActive = schedule[`active${capitalizedDay}`];
      const today = schedule[currentDay] || [];
      let lastClose = null;
      if (today.length > 0) {
        lastClose = today.reduce((max, slot) => slot.closesAt > max ? slot.closesAt : max, today[0].closesAt);
      }
      let now = new Date();
      let nowStr = now.toTimeString().slice(0,5);
      let showEndOfDayMsg = false;
      if (lastClose && isDayActive) {
        showEndOfDayMsg = nowStr > lastClose;
      }
      if (!isDayActive) {
        this.$router.push({ path: '/tracking/1' });
        return false;
      }
      if (showEndOfDayMsg) {
        this.$router.push({ path: '/tracking/1' });
        return false;
      }
      return true;
    };
    // Suscripción en tiempo real
    this.unsubscribeSchedule = businessRef.onSnapshot((doc) => {
      if (doc.exists && doc.data().schedule) {
        checkSchedule(doc.data().schedule);
      }
    });
    // Validación inicial
    const businessDoc = await businessRef.get();
    if (businessDoc.exists && businessDoc.data().schedule) {
      if (!checkSchedule(businessDoc.data().schedule)) return;
    }

    this.$store.commit("setLoading", "Cargando...");
    this.$store.commit("setNavBar", true);
    let container = document.getElementById("app");
    container.style.height = "100vh";

    this.showSearchMobileF(false);

    this.isMobile = mobile();

    // console.log(this.isMobile);

    let menu = document.getElementById("menu");
    if (menu) {
      menu.classList.add("router-link-exact-active");
      menu.classList.add("router-link-active");
    }

    this.serverUrl = await db.collection(`settings`).doc("urls").get();
    this.serverUrl = this.serverUrl.data().drivingUrl;

    await this.$binding(
      "globals",
      db.collection(`settings`).doc("global")
    ).then(async (globals) => {
      this.useGoogleSearch = globals.errands.useGoogleSearch;
    });

    if (this.$store.state.user) {
      this.init();
    } else {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type == "setUser") {
          this.init();
        }
      });
    }
    try {
    } catch (error) {}

    this.map = this.$refs.myMap.mapObject;

    this.pointsReference = this.$refs["detail"]
      ? this.$refs["detail"].$refs["points-c"]
      : {};

    this.$nextTick(() => {
      // this.routeControl = L.Routing.control({
      //   // router: L.Routing.osrmv1({
      //   //   serviceUrl:
      //   //     "https://us-central1-el-ocho.cloudfunctions.net/httpGetDistance",
      //   //   profile: "driving",
      //   //   timeout: 30 * 1000,
      //   //   routingOptions: {
      //   //     alternatives: false,
      //   //     steps: true,
      //   //   },
      //   //   polylinePrecision: 5,
      //   //   useHints: true,
      //   //   suppressDemoServerWarning: false,
      //   //   language: "es",
      //   // }),
      //   lineOptions: {
      //     styles: [
      //       { color: "#00cdbc", opacity: 1, weight: 3, className: "route" },
      //     ],
      //     addWaypoints: false,
      //   },
      //   altLineOptions: {
      //     styles: [
      //       { color: "#00cdbc", opacity: 1, weight: 3, className: "routeAlt" },
      //     ],
      //     addWaypoints: false,
      //   },
      //   autoRoute: false,
      //   routeWhileDragging: true,
      //   loading: false,
      // })

      //   .on("routesfound routingerror", async (e) => {
      //     this.loading = false;
      //     let routes = e.routes;

      //     let distance = Math.ceil(routes[0].summary.totalDistance / 1000);
      //     let extraKm =
      //       distance > this.business.kmConfiguration.maxKmAllowed
      //         ? distance - this.business.kmConfiguration.maxKmAllowed
      //         : 0;

      //     this.$set(this.routeData, "routeName", routes[0].name);

      //     this.$set(
      //       this.routeData,
      //       "routeDistance",
      //       routes[0].summary.totalDistance
      //     );

      //     this.$set(this.routeData, "routeTime", routes[0].summary.totalTime);

      //     if (this.business.flatRate) {
      //       this.$set(this.routeData, "routeCost", this.business.flatRatePrice);
      //     } else {
      //       let sumPickUpDropOff =
      //         this.business.kmConfiguration.pickUp +
      //         this.business.kmConfiguration.dropOff;

      //       let sumAddStop =
      //         this.waypoints.length > 2
      //           ? this.business.kmConfiguration.addStop *
      //             (this.waypoints.length - 2)
      //           : 0;

      //       let sumCostPerKm =
      //         distance <= this.business.kmConfiguration.maxKmAllowed
      //           ? distance * this.business.kmConfiguration.costPerKm
      //           : this.business.kmConfiguration.maxKmAllowed *
      //               this.business.kmConfiguration.costPerKm +
      //             extraKm * this.business.kmConfiguration.extraKmCharge;

      //       let total = sumPickUpDropOff + sumAddStop + sumCostPerKm;

      //       this.$set(this.routeData, "routeCost", total);
      //     }
      //   })
      //   .addTo(this.$refs.myMap.mapObject);

      // L.Routing.errorControl(this.routeControl).addTo(this.map);

      // console.log("this.useGoogleSearch", this.useGoogleSearch);

      this.geoCoder = L.Control.geocoder({
        geocoder: this.useGoogleSearch
          ? new L.Control.Geocoder.Google(process.env.VUE_APP_MY_WEB_API_KEY)
          : "",

        defaultMarkGeocode: false,
      })

        .on("startgeocode", (e) => {
          this.$store.commit("setLoading", "Buscando coincidencias...");
        })
        .on("finishgeocode", (e) => {
          this.searchResults = e.results.filter(
            (e) => e.name != "San Pedro Sula, Honduras"
          );

          if (this.searchResults.length == 0) {
            this.snackbarText = "Búsqueda sin resultados.";
            this.snackbarColor = "red darken-2";
            this.snackbar = true;
          }

          this.$store.commit("setLoading", false);
        })
        .addTo(this.map);
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        navigator.geolocation.watchPosition((e) => {
          if (e) {
            this.showPosition(e);
          }
        });
      });
    }

    this.map.on("click", (e) => {
      let classes = e.originalEvent.srcElement.classList;

      if (this.generating) {
        return;
      }

      this.currentZone = e.originalEvent.srcElement.zone;

      if (
        Object.values(classes).indexOf("vue2leaflet-map") >= 0 &&
        this.business.geofenceActive
      ) {
        return false;
      }

      if (Object.values(classes).indexOf("leaflet-marker-icon") >= 0) {
        let markerType = null;
        for (let i = 1; i < 30; i++) {
          if (classes.contains(`marker-stop-${i}`)) {
            this.selectedPoint = i;
          }
        }
        markerType = "stop";

        this.pointsReference.selectedPoint = this.selectedPoint - 1;

        this.markerPopUp(e, markerType);
        return;
      } else if (this.business.pointsNumber > this.waypoints.length) {
        this.mapPopUp(e);
        return;
      }
    });
  },
  filters: {
    currency: function (amount) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HNL",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },
  },
  computed: {
    sortedPoints: function () {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }

      return this.points.sort(compare);
    },
    styleFunction() {
      const fillColor = this.fillColor;
      return () => {
        return {
          weight: 2,
          color: "#ff0000",
          opacity: 0.1,
          fillColor: fillColor,
          fillOpacity: 0.1,
        };
      };
    },
    deliveryTime() {
      if (this.timeData.soon) {
        return "Lo antes posible";
      } else {
        return moment(
          `${this.timeData.date} ${this.timeData.time}`,
          "YYYY-MM-DD hh:mm"
        ).format("DD/MMM/YY hh:mm A");
      }
    },
  },
  methods: {
    ...mapActions(["showSearchMobileF"]),
    closeConfirm() {
      this.confirmDialog = false;
    },

    async getRouteData() {
      if (this.waypoints.length > 1) {
        let queryCoordinates = "";

        for (let i = 0; i < this.waypoints.length; i++) {
          let point = this.waypoints[i];
          queryCoordinates += `${point.lng},${point.lat};`;
        }

        queryCoordinates = queryCoordinates.substring(
          0,
          queryCoordinates.length - 1
        );

        let url = `${this.serverUrl}${queryCoordinates}?geometries=geojson`;

        axios.get(url).then((response) => {
          this.polygon = response.data.routes[0].geometry.coordinates;

          this.polygon = this.polygon.map((e) => {
            return [e[1], e[0]];
          });

          let distance = Math.ceil(response.data.routes[0].distance / 1000);
          this.routeData.routeDistance = response.data.routes[0].distance;

          let extraKm =
            distance > this.business.kmConfiguration.maxKmAllowed
              ? distance - this.business.kmConfiguration.maxKmAllowed
              : 0;

          if (this.business.flatRate) {
            this.routeData.routeCost = this.business.flatRatePrice;
          } else {
            let sumPickUpDropOff =
              this.business.kmConfiguration.pickUp +
              this.business.kmConfiguration.dropOff;

            let sumAddStop =
              this.waypoints.length > 2
                ? this.business.kmConfiguration.addStop *
                  (this.waypoints.length - 2)
                : 0;

            let sumCostPerKm =
              distance <= this.business.kmConfiguration.maxKmAllowed
                ? distance * this.business.kmConfiguration.costPerKm
                : this.business.kmConfiguration.maxKmAllowed *
                    this.business.kmConfiguration.costPerKm +
                  extraKm * this.business.kmConfiguration.extraKmCharge;

            let total = sumPickUpDropOff + sumAddStop + sumCostPerKm;

            this.routeData.routeCost = total;
          }
        });
      }
    },

    async positionUpdated(e, id) {
      let isValid = await this.checkPoint(e);

      if (isValid) {
        this.waypoints[id] = latLng(e);
      }

      this.getRouteData();
      this.recenterMap();
    },

    timeSelected(e) {
      this.timePickerDialog = false;
      this.timeData = e;
    },
    showTimePicker() {
      this.timePickerDialog = true;
    },

    deletePoint2(index) {
      this.selectedPoint = index;
      this.deletePoint();
    },

    showChanged(e) {
      this.detailsActive = e;
      this.recenterMap();
      let el = document.getElementsByClassName("leaflet-control-zoom");
      let position = document.getElementById("position");

      if (position) {
        position.setAttribute(
          "style",
          `right:${e ? "410px" : "10px"}!important`
        );
      }

      if (el) {
        el[0].setAttribute("style", `right:${e ? "405px" : "10px"}!important`);
      }
    },
    exit() {
      this.exitDialog = false;
      this.$router.push({ path: this.to.fullPath });
    },
    editPointFields(point) {
      this.selectedIndexPoint = point.index;
      this.pointToEdit = Object.assign({}, point.data);
      this.editPointDialog = true;
    },
    updatePoint(data) {
      this.routeData[`point_${this.selectedIndexPoint}`].contactName =
        data.contactName;
      this.routeData[`point_${this.selectedIndexPoint}`].contactPhone =
        data.contactPhone;
      this.routeData[`point_${this.selectedIndexPoint}`].comments =
        data.comments;

      this.editPointDialog = false;

      this.map.closePopup();
    },
    cancel() {
      this.to = null;
      this.exitDialog = false;
    },
    centerUpdated(e) {
      this.center = e;
    },
    showPosition(position) {
      if (this.myLocationMarket) {
        this.map.removeLayer(this.myLocationMarket);
      }

      this.position = latLng(
        position.coords.latitude,
        position.coords.longitude
      );

      var LeafIcon = L.Icon.extend({
        options: {
          iconSize: [15, 15],
          className: "blink",
        },
      });

      var greenIcon = new LeafIcon({
        iconUrl: require("@/assets/point2.png"),
      });

      this.myLocationMarket = L.marker(this.position, { icon: greenIcon })
        .addTo(this.map)
        .on("click", (e) => {});
    },

    centerMyPosition() {
      this.center = this.position;
      this.zoom = 15;
      setTimeout(() => {
        while (this.zoom < 20) {
          this.zoom++;
        }
      }, 500);
    },
    validateFields() {
      return new Promise((resolve, reject) => {
        for (let i = 1; i <= this.waypoints.length; i++) {
          const point = this.routeData[`point_${i}`];
          if (point) {
            if (!point.contactPhone || !point.contactName) {
              this.snackbarText =
                "Debe completar los nombres de contacto y números de teléfono en cada punto.";
              this.snackbar = true;
              this.snackbarColor = "red darken-2";

              this.pointsReference.selectedPoint = i - 1;
              this.pointsReference.validation = true;
              return resolve(false);
            }
          }
        }
        let timeData = this.$refs.detail
          ? this.$refs.detail.timeData
          : this.timeData;

        if (
          timeData &&
          !timeData.soon &&
          (timeData.hour == "" || timeData.minute == "")
        ) {
          this.snackbarText = "Ingrese una hora de inicio válida.";
          this.snackbar = true;
          this.snackbarColor = "red darken-2";

          return resolve(false);
        }

        return resolve(true);
      });
    },

    async preValidation() {
      this.confirmDialog = false;
      let validation = await this.validateFields();

      if (!validation) {
        return 0;
      }

      this.showDetails = true;
    },

    async createErrand() {
      this.generating = true;
      this.loading = true;

      let timeData = this.$refs.detail
        ? this.$refs.detail.timeData
        : this.timeData;

      let deliveryTime = null;

      if (!timeData.soon) {
        deliveryTime = moment(
          `${timeData.date} ${timeData.time}`,
          "YYYY-MM-DD HH:mm:ss"
        )
          .set("seconds", 30)
          .format("DD-MM-YYYY HH:mm:ss");
      }

      this.map._handlers.forEach(function (handler) {
        handler.disable();
      });

      this.pointsReference.selectedPoint = null;

      if (!this.business.paymentType) {
        this.snackbarText =
          "Este comercio no tiene ninguna configuración de pago establecido.";
        this.snackbar = true;
        this.snackbarColor = "red darken-2";

        return;
      }

      let paymentQuery = await db
        .collection("paymentGateways")
        .doc(this.business.paymentType)
        .get();

      let payment = paymentQuery.data() ? paymentQuery.data().paymentType : "";

      if (
        payment == "card" &&
        (!this.business.selectedCard || !this.business.ochoUserId)
      ) {
        this.snackbarText =
          "La configuración de la tarjeta de crédito está incompleta.";
        this.snackbarColor = "red darken-2";
        this.snackbar = true;

        return;
      }

      let points = [];

      for (let i = 1; i <= this.waypoints.length; i++) {
        const point = this.routeData[`point_${i}`];

        if (point) {
          points.push({
            address: point.address ? point.address.join(", ") : "",
            city: this.business.city,
            country: "Honduras",
            countryCode: {
              name: "Honduras",
              topLevelDomain: [".hn"],
              alpha2Code: "HN",
              alpha3Code: "HND",
              callingCodes: ["504"],
              capital: "Tegucigalpa",
              altSpellings: [
                "HN",
                "Republic of Honduras",
                "República de Honduras",
              ],
              region: "Americas",
              subregion: "Central America",
              population: 8576532,
              latlng: [15, -86.5],
              demonym: "Honduran",
              area: 112492,
              gini: 57,
              timezones: ["UTC-06:00"],
              borders: ["GTM", "SLV", "NIC"],
              nativeName: "Honduras",
              numericCode: "340",
              currencies: [
                {
                  code: "HNL",
                  name: "Honduran lempira",
                  symbol: "L",
                },
              ],
              languages: [
                {
                  iso639_1: "es",
                  iso639_2: "spa",
                  name: "Spanish",
                  nativeName: "Español",
                },
              ],
              translations: {
                de: "Honduras",
                es: "Honduras",
                fr: "Honduras",
                ja: "ホンジュラス",
                it: "Honduras",
                br: "Honduras",
                pt: "Honduras",
                nl: "Honduras",
                hr: "Honduras",
                fa: "هندوراس",
              },
              flag: "https://restcountries.eu/data/hnd.svg",
              regionalBlocs: [
                {
                  acronym: "CAIS",
                  name: "Central American Integration System",
                  otherAcronyms: ["SICA"],
                  otherNames: ["Sistema de la Integración Centroamericana,"],
                },
              ],
              cioc: "HON",
            },
            geo: {
              geopoint: {
                _lat: point.latLng.lat,
                _long: point.latLng.lng,
              },
            },
            instructions: point.comments ? point.comments : "",
            name: point.contactName ? point.contactName : "",
            phone: point.contactPhone ? point.contactPhone : "",
            zone: point.zone ? point.zone : "",
          });
        }
      }

      let errand = {
        channel: "ocho_cargo",
        coupon: null,
        distance: this.routeData.routeDistance / 1000,
        errandCarry: "",
        location: this.position ? this.position : null,
        payment: this.business.paymentType,
        paymentToken: payment == "card" ? this.business.selectedCard : "",
        roundTrip: false,
        points,
        sessionId: "",
        startTime: "",
        subTotal: this.routeData.routeCost,
        tip: 0,
        total: this.routeData.routeCost,
        businessId: this.business[".key"],
        user: this.business.ochoUserId,
        city: this.business.city,
      };

      if (deliveryTime) {
        errand.deliveryTime = deliveryTime;
      }

      console.log(errand);

      this.activeButton = false;
      this.$store.commit("setLoading", "Generando mandado...");

      var callableCargoGenerateErrand = fb
        .functions()
        .httpsCallable("callableCargoGenerateErrand");
      callableCargoGenerateErrand(errand)
        .then(() => {
          this.showDetails = false;
          this.$store.commit("setLoading", "Mandado creado");
          this.generating = false;
          this.waypoints = [];

          this.map._handlers.forEach(function (handler) {
            handler.enable();
          });
          setTimeout(() => {
            this.$router.push({ path: "/tracking/1" });
          }, 2000);
        })
        .catch((error) => {
          this.$refs.confirmErrand.failed(error.message);
        });
    },

    async positionsUpdated(data) {
      this.waypoints = data;

      for (let i = 0; i < data.length; i++) {
        const point = data[i];
        await this.reverseGeo(
          point.latLng,
          `point_${i + 1}`,
          { reset: true },
          point
        );
      }

      this.redrawMarkers();
    },

    async init() {
      await this.$binding(
        "business",
        db
          .collection(`businessesCorporative`)
          .doc(this.$store.state.user.businessID)
      );

      if (this.business.city) {
        await this.$binding(
          "city",
          db.collection(`cities`).doc(this.business.city)
        );
      }

      if (this.city && this.city.coordinates) {
        this.center = latLng(
          this.city.coordinates.latitude,
          this.city.coordinates.longitude
        );
      }

      await this.$binding(
        "points",
        db
          .collection("businessesCorporative")
          .doc(this.$store.state.user.businessID)
          .collection("points")
          .where("deleted", "==", false)
          .where("active", "==", true)
      );

      if (this.business.geofenceActive) {
        await this.$binding(
          "globals",
          db.collection(`settings`).doc("global")
        ).then(async (globals) => {
          let geojson = JSON.parse(globals.coverageZone);

          let geoJsonLayer = L.geoJSON(geojson, {
            style: function (feature) {
              return {
                color: feature.properties.color,
                weight: 0,
                opacity: 1,
                fillOpacity: 0.1,
              };
            },
          }).addTo(this.map);

          geoJsonLayer.eachLayer((layer) => {
            if (layer.feature.properties.color != "transparent") {
              this.polygons.push(layer);
            }

            layer._path.id = `${layer.feature.properties.city}`;
            layer._path.zone = layer.feature.properties.name;
            layer._path.classList.add("geofence");
          });

          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.showPosition);
          }

          this.$store.commit("setLoading", false);
        });
        // .catch(() => {
        // });
      } else {
        this.$store.commit("setLoading", false);
      }
    },
    async geoQuerySearch() {
      this.searchResults = [];

      if (this.searchTerm) {
        var re =
          /[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)/;
        let result = re.exec(this.searchTerm);

        if (result && result.length) {
          let request = await axios.get(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${result[0]}&key=${process.env.VUE_APP_MY_WEB_API_KEY}`
          );

          if (
            request.data &&
            request.data.plus_code &&
            request.data.plus_code.compound_code
          ) {
            let query = request.data.plus_code.compound_code;

            this.geoCoder.setQuery(query);
            this.geoCoder._geocode();
          } else {
            this.snackbarText = "El punto seleccionado no ha sido encontrado.";
            this.snackbarColor = "red darken-2";
            this.snackbar = true;
          }
        } else {
          this.geoCoder.setQuery(
            `${this.searchTerm} ${this.city ? this.city.name : ""} honduras`
          );
          this.geoCoder._geocode();
        }
      }
    },
    async geoQuerySelect(selection) {
      this.searchResults = [];
      this.searchTerm = "";

      let isValid = await this.checkPoint(latLng(selection.center));

      if (isValid) {
        this.waypoints.push(latLng(selection.center));

        await this.reverseGeo(
          latLng(selection.center),
          `point_${this.waypoints.length}`
        );

        this.redrawMarkers();
        setTimeout(() => {
          this.center = latLng(selection.center);
        }, 500);

        this.selectedIndexPoint = this.waypoints.length;
        this.pointToEdit = Object.assign(
          {},
          this.routeData[`point_${this.waypoints.length}`]
        );

        setTimeout(() => {
          this.editPointDialog = true;
        }, 300);
      } else {
        this.snackbarText =
          "El área seleccionada está fuera de la zona de cobertura.";
        this.snackbar = true;
        this.snackbarColor = "red darken-2";
      }
    },

    createButton(label, container, classes, point) {
      let btn = L.DomUtil.create("button", "", container);
      btn.setAttribute("type", "button");
      btn.setAttribute("class", "waypointBtn " + (classes || ""));
      btn.innerHTML = label;

      btn.addEventListener("click", async () => {
        //Este evento se dispara cada vez que se agrega un punto
        this.waypoints.push(latLng(point.lat, point.lng));

        this.selectedIndexPoint = this.waypoints.length;

        await this.reverseGeo(
          latLng(point.lat, point.lng),
          `point_${this.selectedIndexPoint}`
        );

        // this.routeData[`point_${this.waypoints.length}`].zone =
        //   this.currentZone;

        if (point.fromDB) {
          this.routeData[`point_${this.waypoints.length}`].contactName =
            point.fullData ? point.fullData.contactName : "";
          this.routeData[`point_${this.waypoints.length}`].contactPhone =
            point.fullData ? point.fullData.contactPhone : "";
        }

        this.redrawMarkers();
        this.map.closePopup();

        // setTimeout(() => {
        //   this.pointsReference.selectedPoint = this.waypoints.length - 1;
        // }, 300);

        this.pointToEdit = Object.assign(
          {},
          this.routeData[`point_${this.selectedIndexPoint}`]
        );

        setTimeout(() => {
          this.editPointDialog = true;
        }, 300);
      });

      return btn;
    },

    createTitle(label, container) {
      let title = L.DomUtil.create("h3", "", container);
      title.setAttribute("type", "button");
      title.setAttribute("class", "waypointContainerTitle");
      title.innerHTML = label;
      return title;
    },

    markerPopUp(e, marker, update) {
      if (update) {
        if (!this.markerPopupElem) {
          return false;
        }
      }

      let container = L.DomUtil.create("div");
      let containerTitle;
      container.setAttribute("class", "waypointDescriptionContainer");
      let body;

      switch (marker) {
        case "stop":
          containerTitle = this.createTitle("Parada", container);
          body = L.DomUtil.create("div", "", container);
          body.setAttribute("class", "waypointContainerTitle");

          body.innerHTML = `<i class="fas fa-pennant icon"></i>`;
          body.innerHTML += `<span class="address1">${
            this.routeData[`point_${this.selectedPoint}`].address[0]
          }</span>`;
          body.innerHTML += `<span class="address2">${this.routeData[
            `point_${this.selectedPoint}`
          ].address
            .slice(1)
            .join(", ")}</span>`;
          body.innerHTML += `<span class="address3">${this.routeData[
            `point_${this.selectedPoint}`
          ].latLng.lat.toFixed(4)},${this.routeData[
            `point_${this.selectedPoint}`
          ].latLng.lng.toFixed(4)}</span>`;
          if (this.routeData[`point_${this.selectedPoint}`].comments) {
            body.innerHTML += `<span class="comments">${
              this.routeData[`point_${this.selectedPoint}`].comments
            }</span>`;
          }

          //buttons div

          let buttonsContainer = L.DomUtil.create("div");
          buttonsContainer.setAttribute("class", "buttonsContainer");

          //EDIT BUTTON
          let editButton = document.createElement("button");
          editButton.innerText = `Editar`;
          editButton.setAttribute("class", "edit");

          editButton.onclick = () => {
            this.editPointFromPopup();
          };

          if (buttonsContainer) {
            buttonsContainer.appendChild(editButton);
          }

          //DELETE BUTTON
          let button = document.createElement("button");
          button.innerText = `Eliminar`;
          button.setAttribute("class", "delete");

          button.onclick = () => {
            this.deletePoint();
          };

          if (buttonsContainer) {
            buttonsContainer.appendChild(button);
          }

          if (body) {
            body.appendChild(buttonsContainer);
          }

          break;
      }

      if (update) {
        if (this.$store.state.sidePanel) {
          this.markerPopupElem.setContent(container);
        }
      } else {
        this.markerPopupElem = L.popup({
          maxWidth: 320,
          autoPanPaddingTopLeft: [100, 100],
          autoPanPaddingBottomRight: [100, 0],
          // closeOnClick: true,
          autoClose: false,
        })
          .setContent(container)
          .setLatLng(e.latlng)
          .on("popupclose, remove", (e) => {
            this.markerPopupElem = null;
          })
          .openOn(this.map);
      }
    },
    reverseGeo(latlng, point, options, allData) {
      // let resetFields = options && options.reset ? true : false;

      return axios
        .get("https://maps.googleapis.com/maps/api/geocode/json", {
          params: {
            latlng: `${latlng.lat},${latlng.lng}`,
            key: "AIzaSyDkX4e0bQziImUkP4MuunB8J4JKGiOC0Kc",
            language: "es-419",
            result_type: "sublocality|neighborhood|route",
          },
        })
        .then((response) => {
          let address = "";
          if (response.data) {
            if (response.data.results.length > 1) {
            }
            let addressBase = response.data.results[0].formatted_address;
            if (response.data.results.length > 1) {
              let removePool = [
                "calle",
                "ca-",
                " av ",
                "av.",
                "bloque",
                "avenida",
                "unnamed",
                "carretera",
                "diagonal",
              ];
              if (
                removePool.some((v) => addressBase.toLowerCase().includes(v))
              ) {
                // There's at least one
                addressBase = response.data.results[1].formatted_address;
              }
            }
            address = addressBase.split(", ");
            if (address[0] == "Unnamed Road") {
              address[0] = "Dirección sin nombre";
            }
          }

          let contactName =
            allData && allData.contactName
              ? allData.contactName
              : this.routeData[point]
              ? this.routeData[point].contactName
              : "";

          let contactPhone =
            allData && allData.contactPhone
              ? allData.contactPhone
              : this.routeData[point]
              ? this.routeData[point].contactPhone
              : "";

          let comments =
            allData && allData.comments
              ? allData.comments
              : this.routeData[point]
              ? this.routeData[point].comments
              : "";

          this.$set(this.routeData, point, {
            latLng: latlng,
            latlng: latlng,
            lat: latlng.lat,
            lng: latlng.lng,
            address: address,
            contactName,
            contactPhone,
            comments,
            zone: this.routeData[point] ? this.routeData[point].zone : "",
          });
        })
        .catch(function (error) {
          // console.log(error);
        })
        .then(() => {
          // always executed
        });
    },
    async mapPopUp(e) {
      let container = L.DomUtil.create("div");

      this.createTitle("Agregar punto a la ruta", container);

      let points = [];

      if (this.position && this.position.lat && this.position.lng) {
        //Agregando mi posición actual siempre y cuando esté activada.
        let validLocation = await this.checkPoint(
          latLng(this.position.lat, this.position.lng)
        );

        if (validLocation) {
          points.push({
            name: "Mi ubicación",
            icon: "fas fa-crosshairs",
            lat: this.position.lat,
            lng: this.position.lng,
          });
        }
      }

      points.push({
        name: "Punto seleccionado",
        icon: "fas fa-map-marked-alt",
        lat: e.latlng.lat,
        lng: e.latlng.lng,
      });

      //print if it is starting point and can change
      if (
        (this.waypoints.length == 0 && this.business.canChangeStartingPoint) ||
        (this.waypoints.length > 0 && this.business.canChangeSecondaryPoints)
      ) {
        for (let i = 0; i < points.length; i++) {
          const point = points[i];

          this.createButton(
            `<i class="${point.icon}"></i>${point.name}`,
            container,
            "startBtn",
            point
          );
        }
      }

      for (let i = 0; i < this.sortedPoints.length; i++) {
        const point = this.sortedPoints[i];

        if (
          this.waypoints.length == 0 &&
          (point.type == "startingPoint" || point.type == "both")
        ) {
          let item = {
            name: point.name,
            icon: "fas fa-map-pin",
            lat: point.address.geopoint.latitude,
            lng: point.address.geopoint.longitude,
            fromDB: true,
            fullData: point,
          };

          this.createButton(
            `<i class="${item.icon}"></i>${item.name}`,
            container,
            "startBtn",
            item
          );
        } else if (
          this.waypoints.length > 0 &&
          (point.type == "secondaryPoint" || point.type == "both")
        ) {
          let item = {
            name: point.name,
            icon: "fas fa-map-pin",
            lat: point.address.geopoint.latitude,
            lng: point.address.geopoint.longitude,
            fromDB: true,
            fullData: point,
          };

          this.createButton(
            `<i class="${item.icon}"></i>${item.name}`,
            container,
            "startBtn",
            item
          );
        }
      }

      container.setAttribute("class", "waypointBtnContainer");

      L.popup({
        maxWidth: 320,
        autoPanPaddingTopLeft: [100, 100],
        autoPanPaddingBottomRight: [100, 0],
        closeOnClick: true,
        autoClose: false,
        tap: false,
      })
        .setContent(container)
        .setLatLng(e.latlng)
        .openOn(this.map);
    },

    recenterMap() {
      let rightMargin = this.detailsActive ? 550 : 120;

      if (this.waypoints.length == 1) {
        this.map.setView(this.waypoints[0], 17, {
          paddingTopLeft: [220, 120],
          paddingBottomRight: [rightMargin, 120],
        });
      } else if (this.waypoints.length > 1) {
        this.map.fitBounds(this.waypoints, {
          paddingTopLeft: this.isMobile ? [50, 50] : [220, 120],
          paddingBottomRight: this.isMobile ? [50, 50] : [rightMargin, 120],
        });
      } else {
        this.map.setView(
          [this.city.coordinates.latitude, this.city.coordinates.longitude],
          15,
          {
            paddingTopLeft: [220, 120],
            paddingBottomRight: [rightMargin, 120],
          }
        );
      }
    },
    async redrawMarkers() {
      // await this.routeControl.setWaypoints(this.waypoints);
      // await this.routeControl.route();

      let position = 1;

      // console.log(this.waypoints);

      // for (let i = 0; i <= this.waypoints.length; i++) {
      // const point = this.waypoints[i];
      // console.log(point);

      // if (point) {
      //   await this.reverseGeo(point, `point_${i + 1}`);
      // }
      // }

      this.$nextTick(() => {
        this.map.eachLayer((layer) => {
          // console.log(layer);

          if (
            layer._latlng &&
            layer._latlng != this.position &&
            layer.setIcon
          ) {
            let marker = L.divIcon({
              className: `custom-marker marker-stop marker-stop-${position}`,
              html: `<div class='marker-pin' data-type='stop'><i class='fas fa-pennant'></i><p>${
                this.isMobile ? "P" : "Punto "
              }${position}<br/></p></div>`,
              iconSize: [128, 58],
              iconAnchor: [64, 58],
              popupAnchor: [64, 58],
            });
            layer.setIcon(marker);
            // layer.on("moveend", async (e) => {
            //   let isValid = await this.checkPoint(e.target._latlng);
            //   if (isValid) {
            //     let classList = e.sourceTarget._icon.classList;
            //     for (let i = 1; i <= this.waypoints.length; i++) {
            //       if (classList.contains(`marker-stop-${i}`)) {
            //         if (
            //           (i == 1 && this.business.canChangeStartingPoint) ||
            //           (i > 1 && this.business.canChangeSecondaryPoints)
            //         ) {
            //           this.waypoints[i - 1] = e.target._latlng;
            //           await this.reverseGeo(e.target._latlng, `point_${i}`);
            //         } else {
            //           this.goBack();
            //         }
            //       }
            //     }
            //   } else {
            //     this.snackbarText =
            //       "El punto seleccionado está fuera de la zona de cobertura.";
            //     this.snackbarColor = "red darken-2";
            //     this.snackbar = true;
            //     this.goBack();
            //   }
            this.recenterMap();
            // });
            position += 1;
          }
        });
      });

      this.getRouteData();
      this.recenterMap();
    },

    async goBack() {
      for (let i = 0; i < this.waypoints.length; i++) {
        // const point = this.waypoints[i];
        // await this.reverseGeo(point, `point_${i + 1}`, { reset: false }, point);
        // console.log(this.waypoints[i]);
      }

      this.redrawMarkers();
    },

    checkPoint(point) {
      return new Promise((resolve, reject) => {
        // console.log(point);

        let response = false;
        var x = point.lat;
        var y = point.lng;

        for (let p = 0; p < this.polygons.length; p++) {
          const polygon = this.polygons[p];
          let polyPoints = polygon.getLatLngs();
          polyPoints = polyPoints[0];

          for (
            var i = 0, j = polyPoints.length - 1;
            i < polyPoints.length;
            j = i++
          ) {
            var xi = polyPoints[i].lat;
            var yi = polyPoints[i].lng;

            var xj = polyPoints[j].lat;
            var yj = polyPoints[j].lng;

            var intersect =
              yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

            if (intersect) {
              response = !response;
            }
          }
        }
        return resolve(!this.business.geofenceActive ? true : response);
      });
    },
    deletePoint() {
      if (this.selectedPoint == 1 && !this.business.canChangeStartingPoint) {
        this.waypoints = [];
      } else {
        this.waypoints = this.waypoints.filter(
          (item, index) => index + 1 != this.selectedPoint
        );
      }

      this.redrawMarkers();
      this.map.closePopup();

      setTimeout(() => {
        this.recenterMap();

        if (this.pointsReference) {
          this.pointsReference.selectedPoint = this.waypoints.length - 1;
        }
      }, 300);
    },
    editPointFromPopup() {
      if (this.routeData[`point_${this.selectedPoint}`]) {
        let point = this.routeData[`point_${this.selectedPoint}`];

        this.editPointFields({ data: point, index: this.selectedPoint });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.waypoints.length) {
      return next();
    }

    if (this.to) {
      next();
    } else {
      this.to = to;
      this.exitDialog = true;
    }
  },
};
</script>

<style lang="scss">
.notMovable {
  pointer-events: none;
  opacity: 0.2;
}

.leaflet-routing-container.leaflet-bar.leaflet-control {
  display: none;
}

.leaflet-control-attribution.leaflet-control {
  display: none;
}

.waypointDescriptionContainer {
  min-width: 240px;
  .waypointContainerTitle {
    color: #00cdbc;
    font-size: 18px;
    font-weight: 900;
    margin-bottom: 10px;
  }

  .icon {
    float: left;
    font-size: 48px;
    margin-right: 10px;
    color: #FF1744;
  }

  .address1 {
    color: #111;
    font-size: 14px;
    font-weight: 900;
    display: block;
    line-height: 12px;
    // white-space: nowrap;
  }
  .address2 {
    color: #111;
    font-size: 12px;
    // line-height: 12px;
    display: block;
    font-weight: normal;
  }

  .address3 {
    display: block;
    color: #FF1744;
    font-size: 12px;
    font-weight: 900;
  }

  .comments {
    display: block;
    font-size: 12px;
    color: #111;
    font-weight: normal;
    background-color: #eee;
    margin: 10px 0;
    padding: 10px 10px;
    border-radius: 10px;
  }
}

.waypointBtnContainer {
  max-height: 70vh;
  overflow-y: auto;
  // position: relative;

  .waypointContainerTitle {
    color: #00cdbc;
    font-size: 18px;
    font-weight: 900;
  }

  .waypointBtn {
    display: block;
    width: 95%;
    appearance: none;
    border: 0;
    margin: 5px 0;
    padding: 10px 10px;
    border-radius: 5px;
    line-height: 24px;
    text-align: left;
    cursor: pointer;

    i {
      font-size: 21px;
      top: 2px;
      width: 21px;
      text-align: center;
      margin-left: 10px;
      margin-right: 10px;
      position: relative;
      color: #FF1744;
    }

    &.hidden {
      display: none !important;
    }
  }
}

// Leaflet overrides
img.leaflet-interactive.leaflet-marker-icon {
  filter: drop-shadow(0px 0px 20px rgba(#000000, 0.8));
}

div.leaflet-marker-icon.custom-marker {
  color: #FF1744;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 50%;
    margin-left: -8px;
    height: 16px;
    width: 16px;
    box-sizing: border-box;
    background-color: transparent;
    border: 1px solid #FF1744;
    box-shadow: 0px 0px 20px rgba(#FF1744, 0.8);
    border-radius: 8px;
    z-index: -1;
  }

  &::before {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%;
    margin-left: -5px;
    height: 10px;
    width: 10px;
    box-sizing: border-box;
    background-color: white;
    border: 3px solid #FF1744;
    box-shadow: 0px 0px 20px rgba(#FF1744, 0.8);
    border-radius: 5px;
    z-index: -1;
  }

  .marker-pin {
    pointer-events: none;
    background-color: #FF1744;
    background-color: white;
    box-shadow: 0px 0px 20px rgba(#FF1744, 0.8);
    height: 42px;
    padding: 5px;
    box-sizing: border-box;
    border-radius: 18px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      bottom: -5px;
      left: 50%;
      margin-left: -5px;
      height: 10px;
      width: 10px;
      transform: rotate(45deg);
      background-color: white;
      border-bottom-right-radius: 2px;
    }

    i {
      color: #FF1744;
      background-color: #FF1744;
      background-color: #fed7c3;
      font-size: 16px;
      float: left;
      padding: 8px;
      position: relative;
      border-radius: 18px;
    }
    p {
      text-align: left;
      font-weight: bold;
      font-size: 16px;
      line-height: 12px;
      margin-left: 5px;
      margin-bottom: 0 !important;
      span {
        color: #111;
        font-weight: 500;
        font-size: 10px;
      }
    }
  }
}

svg g path.leaflet-interactive.route {
  filter: url(#shadowAlt);
}

svg g path.leaflet-interactive.routeAlt {
  filter: url(#shadowAlt);
}

.leaflet-pane.leaflet-overlay-pane svg g path.leaflet-interactive:not(.route) {
  stroke-linejoin: round;
  filter: url(#shadow);
}

.leaflet-control-geocoder-icon {
  border: none;
  background: none;
  background-color: #FF1744;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  font-family: "Font Awesome 5 Pro";
  font-style: normal;
  background-color: #FF1744;
  border-bottom: none;
  width: 28px;
  height: 28px;
  line-height: 28px;
  display: block;
  text-align: center;
  text-decoration: none;
  color: white;

  &::after {
    position: absolute;
    top: 7px;
    left: 10px;
    content: "\f002";
    font-size: 21px;
  }
}

.leaflet-control-geocoder {
  background: #FF1744;
  min-width: 32px;
  min-height: 32px;
  display: none;
  line-height: 32px;

  font-weight: bold;
  color: white;
  text-decoration: none;
  margin: 0 5px;
  box-sizing: content-box;
  text-align: center;
  padding: 5px;
  border-radius: 18px !important;
  color: white;
  background-color: #FF1744;
  z-index: 2;
  filter: drop-shadow(0px 0px 20px rgba(#FF1744, 0.8));
}

.leaflet-bar {
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);
  box-shadow: none;
  border-radius: 4px;
}
.leaflet-bar a,
.leaflet-bar a:hover {
  background-color: #fff;
  width: 26px;
  height: 26px;
  line-height: 26px;
  display: block;
  text-align: center;
  text-decoration: none;
  color: black;
}
.leaflet-bar a,
.leaflet-control-layers-toggle {
  background-position: 50% 50%;
  background-repeat: no-repeat;
  display: block;
}
.leaflet-bar a:hover {
  background-color: #f4f4f4;
}
.leaflet-bar a:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.leaflet-bar a:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom: none;
}
.leaflet-bar a.leaflet-disabled {
  cursor: default;
  background-color: #f4f4f4;
  color: #bbb;
}

.leaflet-touch .leaflet-bar a {
  width: 30px;
  height: 30px;
  line-height: 30px;
}
.leaflet-touch .leaflet-bar a:first-child {
  border-radius: 20px !important;
  padding: 4px;
}
.leaflet-touch .leaflet-bar a:last-child {
  border-radius: 20px !important;
  padding: 4px;
}

.leaflet-touch .leaflet-control-layers,
.leaflet-touch .leaflet-bar {
  border: 0 !important;
}

/* popup */

.leaflet-popup {
  position: absolute;
  text-align: center;
  margin-bottom: 20px;
}
.leaflet-popup-content-wrapper {
  padding: 1px;
  text-align: left;
  border-radius: 15px;
}
// .leaflet-popup-content {
//   margin: 15px 15px;
//   line-height: 1.4;
// }
.leaflet-popup-content p {
  margin: 18px 0;
}
.leaflet-popup-tip-container {
  width: 40px;
  height: 20px;
  position: absolute;
  left: 50%;
  margin-left: -20px;
  overflow: hidden;
  pointer-events: none;
}
.leaflet-popup-tip {
  width: 17px;
  height: 17px;
  padding: 1px;
  border-radius: 5px;
  margin: -12px auto 0;

  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  background: white;
  color: #333;
  box-shadow: none;
  filter: drop-shadow(0 0 20px rgba(#000000, 0.3));
}
.leaflet-container a.leaflet-popup-close-button {
  // position: absolute;
  top: -10px;
  right: -10px;
  // padding: 0;
  // line-height: 30px;
  // background: initial;
  border-radius: 50%;
  background-color: #FF1744;
  color: white;
  // border: none;
  // text-align: center;
  width: 32px;
  height: 32px;
  // box-shadow: 0 0 30px rgba(#FF1744, 0.5);
  // text-decoration: none;
  // font-weight: bold;
}

.leaflet-popup-scrolled {
  overflow: auto;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}

// .leaflet-oldie .leaflet-popup-content-wrapper {
//   zoom: 1;
// }
.leaflet-oldie .leaflet-popup-tip {
  width: 24px;
  margin: 0 auto;

  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)";
  filter: progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678);
}
.leaflet-oldie .leaflet-popup-tip-container {
  margin-top: -1px;
}

.leaflet-oldie .leaflet-control-zoom,
.leaflet-oldie .leaflet-control-layers,
.leaflet-oldie .leaflet-popup-content-wrapper,
.leaflet-oldie .leaflet-popup-tip {
  border: 1px solid #999;
}

.anchor-class {
  color: #506fb4 !important;
  font-weight: bold;
  cursor: pointer;
  font-size: 15px;
}

.sort-points {
  position: absolute;
  top: 20px;
  left: 100px;
  z-index: 2;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
}

.sort-points p {
  cursor: pointer;
  margin-top: 20px;
  text-align: start;
}

.delete {
  background-color: red;
  color: white;
  padding: 10px;
  width: 95%;
  margin-top: 15px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  display: inline;
}

.edit {
  background-color: #FF1744;
  color: white;
  padding: 10px;
  width: 95%;
  margin-top: 15px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  display: inline;
}

.buttonsContainer {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
}

.cash {
  padding: 15px;
  background-color: #FF1744;
  color: white;
  border-radius: 20px;
  min-width: 300px;
  max-width: 300px;
  margin: 10px;
  border: 0;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 0px 5px 15px 5px #dddddd;
  box-shadow: 0px 5px 15px 5px #dddddd;
}

.cash i {
  margin-right: 20px;
  font-size: 20px;
}

.blink {
  animation: pulse 2s linear infinite;
  border-radius: 20px;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 #FF1744;
  }
  70% {
    -webkit-box-shadow: 0 0 0 30px #f06925af;
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 #fc7d3eb6;
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 #FF1744;
    box-shadow: 0 0 0 0 #FF1744;
  }

  40% {
    -moz-box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
    box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
  }

  70% {
    -moz-box-shadow: 0 0 0 30px rgba(148, 147, 147, 0);
    box-shadow: 0 0 0 30px rgba(148, 147, 147, 0);
  }

  100% {
    -moz-box-shadow: 0 0 0 0 rgba(148, 147, 147, 0);
    box-shadow: 0 0 0 0 rgba(148, 147, 147, 0);
  }
}

.collapsible {
  background-color: #777;
  color: white;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
}

// .active,
// .collapsible:hover {
//   // background-color: #555;
// }

.content {
  padding: 0 18px;
  display: none;
  overflow: hidden;
  background-color: #f1f1f1;
}

.clic {
  margin-top: 200px;
  color: rgba(128, 128, 128, 0.589);
}

.details {
  bottom: 0;
  width: 100%;
  max-height: 20vh;
  min-height: 15vh;
  padding-bottom: 10px;
  overflow: auto;
  z-index: 1000;
}

.details-second {
  height: 100%;
  // background-color: blue;
  width: 100%;
  display: flex;
  align-items: flex-end;

  // height: 100%;
  div {
    width: 100%;
    // height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 20vh;
  }
}

.details p {
  margin-top: 10px;
}

.costs {
  margin-left: 30px;
  margin-bottom: 10px;
  // background-color: chocolate;
  text-align: start;
}

.dialog-btn {
  padding: 15px 0 15px 0;
  display: grid;
  // height: 35px;
  border: 0;
  grid-template-columns: 48% 48%;
  justify-content: space-around;
  margin-top: 30px;
  // margin-bottom: 30px;

  // button {
  //   cursor: pointer;
  //   border: 0;
  //   border-radius: 10px;
  //   font-weight: bold;
  // }

  // .confirm {
  //   color: red;
  //   background-color: red;
  // }
}

.version {
  // right: 10px;
  // position: absolute;
  // bottom: 5px;
  color: gray;
}

// .header {
//   height: 10vh;
//   max-height: 10vh;
//   // background-color: yellow;
//   padding: 20px 5px 10px 5px;
// }

.tag {
  position: fixed;
  top: 25px;
  left: 8%;
  background-color: #ffffff;
  z-index: 2;
  color: #00cdbc;
  font-weight: bold;
  padding: 5px;
  max-width: 200px;
  overflow: hidden;
  border-radius: 5px;
}

.hide-icon {
  background-color: #ffffff;
  position: absolute;
  top: 48%;
  right: 350px;
  z-index: 9999;
  width: 35px;
  height: 80px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid rgba(128, 128, 128, 0.39);
  border-right: 0;
  transition: all 0.1s ease-in-out;

  i {
    font-size: 25px;
  }
}

@media screen and (max-width: 992px) {
  div.leaflet-marker-icon.custom-marker {
    width: 80px !important;
  }

  // mai
}
</style>

